if (typeof cpac !== 'undefined') {
    cpac.schedule = {};
    cpac.schedule.week = {
        updating: false
        ,formId: 'courtScheduleProperties'
        ,divId: 'court-properties-container'
         
        ,reserveButtonClick: function (url, buttonId) {
            cpac.tennis.toggleReserveButtons(buttonId);
            
            if( ! $j( '#' + buttonId ).hasClass('active') ) {
                this.updating = true;
                
                var resourcesPropertiesForm = $j('#' + this.formId);
                var formData = resourcesPropertiesForm.serialize();
    
                url += url.indexOf('?') > -1 ? '&ajax=true' : '?&ajax=true';
                showAjaxStarted();
                
                var ajaxDiv = $(this.divId);
                new Ajax.Request( url, {
                    method: 'post',
                    parameters: formData,
                    onComplete: function(request) {
                        showResponse(request, ajaxDiv);
    
                        cpac.schedule.week.updating = false;
                        $j('#edit-button').hide();
                        $j('#' + buttonId ).toggleClass('active');
                    },
                    onFailure: reportAjaxError
                });
            } else {
                var resourcesPropertiesForm = $j('#' + this.formId);
                var href =  resourcesPropertiesForm.attr('home_url');
    
                showResources( this.formId, href, this.divId, function(){
                  this.updating = false;
                  $j('#' + buttonId ).toggleClass('active');
                });
            }
        } 
        
        ,reserveBlockTime: function(button, url) {
            try {
                var buttonId = $j(button).attr('id');
                if (typeof (url) == 'undefined') {
                    url = $j(button).attr('href');
                }
                this.reserveButtonClick(url, buttonId);
            } catch(e) {
                cpac.error(e)
            }
        }
        
        ,blockTimeSave: function (dontDisplayError) {
            
            this.reserveCourtSave({
                 toggle: 'reserve-block-button'
            }, dontDisplayError );
        }
        
        ,reserveCourtSave: function( argv, dontDisplayError ) {
            if( Ajax.activeRequestCount || $j.active ) {
                var self = this;
                if( ! this.reserveCourtSaveBusyInterval ) {
                    this.reserveCourtSaveBusyInterval = setInterval(function(){
                        self.reserveCourtSave( argv, dontDisplayError );
                    }, 100);
                }
                return;
            }
            clearInterval( this.reserveCourtSaveBusyInterval );
            this.reserveCourtSaveBusyInterval = null;
    
            argv = argv || {};
    
            if( ! argv.toggle )
                argv.toggle = 'reserve-court-button';
    
            if( this.updating ){
                return;
            }
    
            var form = '';
            if( ! argv.form ) {
                form = $(this.formId);
            } else {
                form = argv.form;
            }
    
            if( ! argv.dontParseGrid ) {
                if( ! parceCourtGreed( form.multiselectdata, dontDisplayError )){
                    return
                }
            }
    
            if( form.cancel )
                form.cancel.value = '0';
            if( form.save )
                form.save.value = '1';
    
            if( argv.beforeSubmit )  {
                if( argv.beforeSubmit( form ) === false ) {
                    return;
                }
            }
    
            this.updating = true;
    
            resourcesPropertiesForm = form;
            formData = form ? $(form).serialize() : '';
            
            if (formData && argv.skipUserAvailability) {
                formData += '&skipUserAvailability=' + argv.skipUserAvailability;
            }
    
            if( ! argv.url ) {
                var url = form.action;
                url += url.indexOf('?') > -1 ? '&ajax=true' : '?&ajax=true';
            } else {
                var url = argv.url;
            }
    
            showAjaxStarted();
    
            var ajaxDiv = $(this.divId);
    
            new Ajax.Request( url, {
                method: 'POST',
                parameters: formData,
                onComplete: function(answer) {
                    if( argv.afterSubmit )  {
                        argv.afterSubmit( form, answer );
                    }
    
                    if( answer.responseText.indexOf('xH3fJdfK9jdwliUf3doiFdvoe8kDx') > 0 ) {
                        cpac.schedule.week.updating = false;
                        showResponseInModal( answer, 'Save', 900, 500 );
                    } else
                    if( answer.responseText.indexOf('Ckd39vdWo03Cl2d3W4o72CIjN4GwD') > 0 ) {
                        cpac.schedule.week.updating = false;
                        showResponseInModal( answer, 'Reservation Summary', 660, 330 );
                    } else
                    if( answer.responseText.indexOf('fddaaa13bc2d872fa1fd14d59ff13ca5') > 0 ) {
                        cpac.tennis.updating = false;
                        showResponseInModal( answer, 'Warning', 460, 150 );
                    } else
                    if( answer.responseText.indexOf('Le83bhY83hf6su53WdjeKje873jLl') > 0 ) {
                        cpac.schedule.week.updating = false;
                        showResponseInModal( answer, 'Confirm Event Dates', 900, 330 );
                    } else
                    if( answer.responseText.indexOf('Fgr93Lcfj3Hrop8dm3ofWo94Pe9dX') > 0 ) {
                        cpac.schedule.week.updating = false;
                        showResponseInModal( answer, 'Warning', 420, 100 );
                    } else
                    if( answer.responseText.indexOf('ySck3qDfl7vEsf4xwQ2h91nUiJ7c4') > 0 ) {
                        cpac.schedule.week.updating = false;
                        if( ! $('ajaxResponseTempContainer')) {
                            $('court-properties-container').insert( new Element('div', {
                                id: 'ajaxResponseTempContainer'
                            }));
                        }
                        showResponse(answer, $('ajaxResponseTempContainer'));
                    } else
                    if (answer.responseText.indexOf('682f436ba7840abb027cb6a8a976605e') > 0) {
                        cpac.schedule.week.updating = false;
                        showResponseInModal(answer, 'Warning', 420, 100);
                    } else
                    if (answer.responseText.indexOf('383a3dfa47880fb4f272a7d8a07669de') > 0) {
                        cpac.schedule.week.updating = false;
                        showResponseInModal(answer, 'Warning', 420, 100);
                    } else
                    if (answer.responseText.indexOf('94faf56faf495c452da95a4f2aa2da54') > 0) {
                        cpac.schedule.week.updating = false;
                        showResponseInModal(answer, 'Warning', 420, 100);
                    } else
                    if( answer.responseText.indexOf('errWin.win.showCenter(true)') > 0 ) {
                        showResponse(answer, ajaxDiv);
                        cpac.schedule.week.updating = false;
                    } else
                    if( answer.responseText.indexOf('wkrfg39dhtlHRFlws628GHherw23t') > 0 ) {
                        // redirect on the page
                        showResponse(answer, ajaxDiv);
                    }else {
                        showResponse(answer, ajaxDiv);
                        cpac.schedule.week.updating = false;
                        if ($( argv.toggle )) {
                            $( argv.toggle ).toggleClassName('active');
                        }
                        if ($('edit-button')) {
                            $('edit-button').show();
                        }
                    }
                },
                onFailure: reportAjaxError
            });
        }
    };
}